//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Articlecard from './articlecard.vue'
import Kirbyimage from './kirbyimage.vue'

	import { mapState,mapMutations  } from 'vuex' 
    const category_label = "Categories"
    const howto_label = "Guides"

    export default
    {
        name: "bloglisting",
        components:{ 
            Kirbyimage, Articlecard
        },
        data(){
            return { 
                articles: null,
                selected_category: category_label,
                selected_howto: howto_label
            }
        },
        computed:
        { 
            select_category_label: function() {
                return this.selected_category;
            },
            select_howto_label: function() {
                return this.selected_howto;
            },

            filtered_articles: function()
            {
                if (this.articles)
                {
                
                console.log("filtering");
                let base_articles = this.articles;

                if (this.articles.code == 200){
                    base_articles = this.articles.result;
                }
                console.log("base articles", this.articles);


                    if (this.selected_category != category_label || this.select_howto_label != howto_label)
                    {

                        base_articles = base_articles.filter((article) => {

                            let match = false;

                            if (this.selected_category != category_label && article.search_tags)
                            {
                                match = article.search_tags.split(',').includes(this.selected_category.trim())
                            }

                            if (this.select_howto_label != howto_label && article.how_to_tags)
                            {
                                match = article.how_to_tags.split(',').includes(this.selected_howto.trim());
                            }

                            return match;
                        });
                    }

                return base_articles;
                }
            },

            ...mapState({
                categories: state => state.global.content.categories ? state.global.content.categories.split(',') : [],
                search_tags: state => state.global.content.globaltags ? state.global.content.globaltags.split(',') : [],
                youtube_url: state => state.global.content.youtube_url
            })

        },   
        props:{
            content: Object,
            page: Object
        },
		async fetch() {
            
            console.log("initiating fetch");

            let $endpoint = '/.netlify/functions/content';
            if (process.server){
                $endpoint = process.env.PRODUCTION_BASE_URL + '/api/query'
            } 
            
             await this.$axios.$post($endpoint,{
				query: "page('" + this.$route.path + "').children.listed",
				select: {
					title: "page.content.title",
					thumb: "page.content.thumbnailimage.toFilesHelper",
                    blog_type: "page.content.blog_type",
                    search_tags: "page.content.search_tags",
                    how_to_tags: "page.content.how_to_tags",
                    card_description: "page.content.card_description",
                    card_linktext: "page.content.card_linktext",
                    card_link: "page.id"

				},
				page: 1,
				limit: 50,
               }, {
                        baseURL: "",
                        auth: "",                                
                        headers: {
                            common: {
                            Authorization: ''
                            }
                        },
                        config: {
                            auth: ""
                        }
                    }
			)
			.then((response) => { 

                if (process.server)
                {
                    
                console.log("response server", response);
				this.articles = response.result.data 
                }
                else{

                console.log("response client", response);
				this.articles = response.data.result.data;
                }
			}).catch((error) => {
                console.log(error);
            });
            
            console.log("finished fetch");
		}

    }

